import React from "react";
import { Dropdown } from "@carbon/react";

export default function HeatmapCameraSelector({
  options = [],
  value,
  disabled,
  onChange,
}) {
  if (!options?.length) return null;

  const safeValue = options.includes(value) ? value : options[0];

  return (
    <div className="heatmap-camera-selector mm-dropdown">
      <Dropdown
        id="heatmap-camera-selector"
        titleText="Cámara"
        label={safeValue || "Todas las cámaras"}
        items={options}
        selectedItem={safeValue}
        itemToString={(item) => item || ""}
        disabled={disabled}
        onChange={({ selectedItem }) => onChange?.(selectedItem || null)}
      />
    </div>
  );
}
